import axios from 'axios';
import {systemEnvironmentApiUrl} from '../../../helpers/url';

/**
 * @param courseId
 * @param voucherCode
 * @returns {Promise<AxiosResponse<any> | never>}
 */
export function verifyVoucher(courseId, voucherCode) {
    return axios
        .get(`${systemEnvironmentApiUrl()}/api/v1/course/${courseId}/voucher/verify/${voucherCode}`)
        .then((response) => response.data);
}



// WEBPACK FOOTER //
// ./src/components/ssv-order/api/voucher.js